<template>
  <div class="top">
    <p class="title fw700" :style="{ 'line-height': '42px', color: '#0F1734' }">Medication Reviews</p>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border position-absolute spinner-class"></div>
    </div>
    <div v-if="!loading">
      <div style="margin-top: 24px; margin-bottom: 24px; display: flex; justify-content: space-between">
        <p class="result-length">{{ reviews.length }} {{ reviews.length > 1 ? "Results" : "Result" }}</p>
      </div>
      <ReviewCard v-for="review in reviews" :reviewData="review" :key="review" :isReviewer="false"/>
    </div>
    <div v-if="!loading && reviews.length === 0">
      <div class="dailogbox">
        <div class="dailog-wrapper">
          <span class="dailog">This {{ role }} did not review any medication yet.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReviewCard from "../../../home/reviews/MedReviewCard.vue"
import { RepositoryFactory } from "../../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "PatientMedReview",
  components: {
    ReviewCard,
  },

  data() {
    return {
      reviews: [],
      id: null,
      loading: true,
      role: "",
    }
  },

  created() {
    console.warn('ViewPatientMedReview.vue is created');
    this.role =
      this.viewUser.role === "patient" ||
      this.viewUser.role === "advocate" ||
      this.viewUser.role === "caregiver" ||
      this.viewUser.role === "doctor" ||
      this.viewUser.role === "hospital" ||
      this.viewUser.role === "nfp" ||
      this.viewUser.role === "hcp" ||
      this.viewUser.role === "clinic"
        ? this.viewUser.role.replace(/\b(\w)/g, s => s.toUpperCase())
        : this.viewUser.role === "clinic_administrator"
        ? "Clinic"
        : "Hospital"

    this.id = this.viewUser.role === "patient" || this.viewUser.role === "advocate" || this.viewUser.role === "caregiver" ? this.viewUser.id : this.viewUser.ext_ref_id
    this.fetch()
  },

  methods: {
    fetch() {
      this.loading = true
      UserRepository.getMedReviews(this.currentCircle.id, 1, 10, this.id, this.viewUser.role).then(res => {
        this.reviews = res.data.data.data ? res.data.data.data : []
        this.loading = false
        console.log("reviews for med", this.reviews)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.dailog {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #33415f;
}

.dailog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 8px;
  width: 100%;
  // height: 115px;
}

.dailogbox {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  // height: 163px;
  background: #f1f5f9;
  border-radius: 8px;
}

.result-length {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #0f1734;
}

.top {
  width: 100%;
}

.title {
  font-size: 32px;

  @media screen and (max-width: 700px) {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/view/ViewPatientMedReview.vue